
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marcas",
      function () {
        return require("private-next-pages/marcas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marcas"])
      });
    }
  